export default {
  LK: {
    pageTitle: "Cuenta personal",
    subscription: {
      yourSubs: "Tu suscripción",
      plan_1: "Gratuita",
      plan_2: "Avanzada",
      plan_3: "Individual",
      changePlan: "Cambiar plan",
      activeFor: "Activa hasta",
      nextPayment: "Próximo pago",
      accessFor: "Acceso disponible hasta",
    },
    settings: "Configuración",
    form: {
      labels: {
        status: "Estado",
        spec_med: "Especialidad",
        position: "Cargo",
        university: "Universidad",
      },
      spec_statValues: {
        doctor: "Médico",
        student: "Estudiante",
        resident: "Residente",
        spec_med: "Empleado de organización médica",
      },
      spec_medValues: {
        Obstetrician: "Obstetra",
        "Obstetrician-gynecologist": "Gineco-obstetra",
        Allergist: "Alergólogo",
        Angiosurgeon: "Angiocirujano",
        Andrologist: "Andrólogo",
        Anesthetist: "Anestesista",
        Anesthesiologist: "Anestesiólogo-reanimatólogo",
        Audiologist: "Audiólogo",
        Bacteriologist: "Bacteriólogo",
        Venereologist: "Venereólogo",
        Vertebrologist: "Vertebrólogo",
        "Laboratory diagnostics doctor": "Médico de diagnóstico de laboratorio",
        "Physiotherapy doctor": "Médico de fisioterapia",
        "Magnetic resonance imaging doctor": "Médico de resonancia magnética",
        GP: "Médico de cabecera",
        "Sports medicine doctor": "Médico de medicina deportiva",
        "Ultrasound diagnostic doctor": "Médico de diagnóstico por ultrasonido",
        "Functional diagnostics doctor": "Médico de diagnóstico funcional",
        Dermatovenerologist: "Dermatovenereólogo",
        Dermatologist: "Dermatólogo",
        "Pediatric gastroenterologist": "Gastroenterólogo pediátrico",
        "Pediatric gynecologist": "Ginecólogo pediátrico",
        "Pediatric cardiologist": "Cardiólogo pediátrico",
        "Pediatric neurologist": "Neurólogo pediátrico",
        "Child psychiatrist": "Psiquiatra infantil",
        "Pediatric dentist": "Odontólogo pediátrico",
        "Pediatric traumatologist-orthopedist":
          "Traumatólogo ortopedista pediátrico",
        "Pediatric urologist-andrologist": "Urólogo andrólogo pediátrico",
        "Pediatric surgeon": "Cirujano pediátrico",
        "Pediatric endocrinologist": "Endocrinólogo pediátrico",
        Nutritionist: "Nutricionista",
        "Other specialty": "Otra especialidad",
        Immunologist: "Inmunólogo",
        "Infectious disease specialist":
          "Especialista en enfermedades infecciosas",
        Cardiologist: "Cardiólogo",
        Kinesiotherapist: "Kinesiólogo",
        "Clinical Pharmacologist": "Farmacólogo clínico",
        Coloproctologist: "Coloproctólogo",
        Cosmetologist: "Cosmetólogo",
        "Laboratory assistant": "Técnico de laboratorio",
        "Speech therapist": "Logopeda",
        "ENT (Otorhinolaryngologist)": "Otorrinolaringólogo",
        Mammologist: "Mastólogo",
        Chiropractor: "Quiropráctico",
        Masseur: "Masajista",
        Nurse: "Enfermera",
        "Medical brother": "Enfermero",
        "Medical Director": "Director médico",
        Mycologist: "Micólogo",
        "Expert in narcology": "Narcólogo",
        Neurologist: "Neurólogo",
        Neurophysiologist: "Neurofisiólogo",
        Neurosurgeon: "Neurocirujano",
        Neonatologist: "Neonatólogo",
        Nephrologist: "Nefrólogo",
        "Oculist (Ophthalmologist)": "Oftalmólogo",
        Oncologist: "Oncólogo",
        Orthopedist: "Ortopedista",
        Osteopath: "Osteópata",
        Parasitologist: "Parasitólogo",
        Periodontist: "Periodoncista",
        Pathologist: "Patólogo",
        Teacher: "Docente",
        Pediatrician: "Pediatra",
        "Plastic surgeon": "Cirujano plástico",
        Proctologist: "Proctólogo",
        "Occupational pathologist": "Patólogo laboral",
        Psychiatrist: "Psiquiatra",
        "Psychiatrist-narcologist": "Psiquiatra-narcólogo",
        Psychologist: "Psicólogo",
        Psychotherapist: "Psicoterapeuta",
        Pulmonologist: "Neumólogo",
        Radiolog: "Radiólogo",
        Rehabilitologist: "Rehabilitador",
        Reanimatologist: "Reanimatólogo",
        Rheumatologist: "Reumatólogo",
        Radiologist: "Radiólogo",
        "Reproductologist (IVF)": "Reproductólogo (FIV)",
        Reflexologist: "Reflexólogo",
        Sexologist: "Sexólogo",
        "Cardiovascular surgeon": "Cirujano cardiovascular",
        Somnologist: "Somnólogo",
        Dentist: "Dentista",
        "Childrens-dentist": "Odontólogo pediátrico",
        "Dental hygienist": "Higienista dental",
        "Dentist-implantologist": "Implantólogo",
        "Dentist-orthodontist": "Ortodontista",
        "Orthopedic dentist": "Odontólogo ortopédico",
        "Dentist-therapist": "Odontólogo general",
        "Dental surgeon": "Cirujano dental",
        Surdolog: "Audiólogo",
        Therapist: "Terapeuta",
        Toxicologist: "Toxicólogo",
        Traumatologist: "Traumatólogo",
        "Traumatologist-orthopedist": "Traumatólogo ortopedista",
        Transplantologist: "Transplantólogo",
        Transfusiologist: "Transfusiólogo",
        Trichologist: "Tricólogo",
        Urologist: "Urólogo",
        Pharmacist: "Farmacéutico",
        Paramedic: "Paramédico",
        Physiotherapist: "Fisioterapeuta",
        Phlebologist: "Flebólogo",
        Phoniatrist: "Foniatra",
        Phthisiatrician: "Tisiólogo",
        Surgeon: "Cirujano",
        "Implant surgeon": "Cirujano implantólogo",
        "Maxillofacial surgeon": "Cirujano maxilofacial",
        Embryologist: "Embriólogo",
        Endocrinologist: "Endocrinólogo",
        Endoscopist: "Endoscopista",
        Epidemiologist: "Epidemiólogo",
        Epileptologist: "Epileptólogo",
      },
    },
  },
};
